
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5" viewBox="0 0 625 625"><path d="M213.173-664.653h621.32v597.846h-621.32z" style="fill:none" transform="matrix(1.00592 0 0 1.04542 -214.436 694.84)"/><path d="M965.877 164.037v43.769l154.143 75.077-152.514 78.347v42.193l198.974-99.034v-38.096L965.877 164.037" style="stroke:#000;stroke-width:.42px" transform="matrix(2.36716 0 0 2.36717 -2211.318 -359.142)"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    